import axios from "axios";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

export const formatINR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "";
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
};

export const WHATSAPP_NUMBER = "917982295008";

export function trackEvent(event_type, meta = {}) {
  const session_id = localStorage.getItem("teak_sid") || undefined;
  axios.post(`${API}/events`, { event_type, session_id, ...meta }).catch(() => {});
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
